export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 flex flex-col md:flex-row items-center">
          <div className="flex-1 p-8 md:p-12 text-center md:text-left">
            <h2 className="text-2xl md:text-4xl font-black text-foreground-900 mb-3">
              移动客户端
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-md">
              青柠影视移动端 App 正在紧锣密鼓开发中，即将支持 iOS 与 Android 双平台。
              届时你将可以在手机上享受同样流畅的高清追剧体验，支持离线缓存、夜间模式和个性化推荐。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center md:justify-start gap-3">
              <a
                href="#contact"
                className="w-full sm:w-auto px-6 py-3 rounded-lg bg-foreground-900 hover:bg-foreground-800 text-white font-medium text-sm transition-all duration-200 cursor-pointer whitespace-nowrap text-center no-underline flex items-center justify-center gap-2"
              >
                <i className="ri-apple-fill text-lg"></i>
                App Store 即将上线
              </a>
              <a
                href="#contact"
                className="w-full sm:w-auto px-6 py-3 rounded-lg bg-primary-500 hover:bg-primary-600 text-white font-medium text-sm transition-all duration-200 cursor-pointer whitespace-nowrap text-center no-underline flex items-center justify-center gap-2"
              >
                <i className="ri-android-fill text-lg"></i>
                安卓版即将上线
              </a>
            </div>
            <p className="text-xs text-foreground-400 mt-4">
              敬请期待 · 上线后将第一时间通知
            </p>
          </div>
          <div className="flex-shrink-0 w-full md:w-[320px] lg:w-[380px] p-4 md:p-0 md:pr-8 flex justify-center">
            <div className="relative w-[180px] h-[320px] md:w-[200px] md:h-[360px] rounded-2xl overflow-hidden shadow-lg border-4 border-background-200/70">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20a%20movie%20streaming%20app%20interface%20with%20warm%20coral%20accents%2C%20dark%20theme%20UI%2C%20movie%20posters%20thumbnails%2C%20clean%20minimal%20design%2C%20entertainment%20app%20aesthetic%2C%20professional%20mockup%20on%20neutral%20background%2C%20soft%20lighting&width=400&height=720&seq=app-mockup-ql&orientation=portrait"
                alt="青柠影视移动客户端界面预览"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}